export const events = [
  {
    id: "love-night-photo",
    title: "某顶流深夜同框事件：从路透到工作室回应",
    category: "love",
    categoryName: "情感八卦",
    year: "2024",
    date: "2024-11-18",
    heat: 986,
    badge: "爆",
    featured: true,
    views: "328.6万",
    readTime: "7 分钟",
    status: "已回应",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20nighttime%20city%20street%20with%20soft%20bokeh%20streetlights%20and%20two%20blurred%20silhouettes%20walking%20apart%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20film%20grain%2C%20documentary%20mood%2C%20no%20identifiable%20faces%2C%20editorial%20photography&width=800&height=450&seq=baoliao-ev-01&orientation=landscape",
    summary:
      "一组深夜街拍在网络流传，两位年轻艺人被拍到同车抵达同一小区。从最初的路透争论，到粉丝与工作室的隔空回应，事件在三天内迅速发酵。",
    tags: ["深夜同框", "路透争议", "工作室回应"],
    content: [
      "事情最早源于一位摄影爱好者在社交平台发布的街拍。画面中，一辆商务车在深夜停靠在某小区门口，随后两名戴口罩的年轻艺人先后下车。由于拍摄角度较远，画面并未出现清晰正脸。",
      "路透流出后，相关话题在两小时内冲上热搜榜前列。支持者认为这只是普通朋友聚会，质疑者则翻出两人此前合作剧集的宣传期互动作为佐证，双方在评论区展开拉锯。",
      "第三天傍晚，其中一方工作室发布简短声明，称艺人私生活不便过多回应，感谢大家的关心，也请尊重个人空间。声明既未直接否认，也未明确承认，被不少网友解读为克制式回应。",
      "截至目前，事件已从单纯的同框讨论，延伸为关于艺人隐私边界与路透拍摄伦理的公共话题。多位法律从业者在社交平台科普了偷拍与二次传播可能涉及的风险。",
    ],
    timeline: [
      { date: "11-15", text: "深夜街拍在网络流传，话题迅速升温" },
      { date: "11-16", text: "双方粉丝就画面细节展开争论，相关词条登上热搜" },
      { date: "11-17", text: "一方工作室发布简短声明，未正面回应" },
      { date: "11-18", text: "关于隐私边界与路透伦理的讨论成为新的焦点" },
    ],
    related: ["love-split-statement", "idol-debut-controversy"],
  },
  {
    id: "variety-backstage-clash",
    title: "王牌综艺录制现场争执风波复盘",
    category: "variety",
    categoryName: "综艺风波",
    year: "2024",
    date: "2024-09-06",
    heat: 912,
    badge: "热",
    featured: true,
    views: "214.3万",
    readTime: "6 分钟",
    status: "已澄清",
    cover:
      "https://readdy.ai/api/search-image?query=Backstage%20television%20studio%20corridor%20with%20tangled%20cables%2C%20empty%20folding%20chairs%20and%20glowing%20monitor%20screens%2C%20warm%20tungsten%20lighting%2C%20shallow%20depth%20of%20field%2C%20cinematic%20editorial%20photography%2C%20no%20people%2C%20moody%20atmosphere&width=800&height=450&seq=baoliao-ev-02&orientation=landscape",
    summary:
      "一段标注为未剪辑现场的短视频在群聊中流传，画面显示两位嘉宾在某综艺录制中情绪激动。节目组随后回应，称网传内容经过拼接。",
    tags: ["现场视频", "剪辑争议", "节目回应"],
    content: [
      "该视频最早出现在娱乐讨论群中，全长不到四十秒。画面里，两位常驻嘉宾在游戏环节结束后出现明显分歧，其中一位起身离开座位。由于收音模糊，具体对话内容无从辨认。",
      "视频扩散后，录制翻车的说法不胫而走。有自称现场观众的网友发帖称，所谓争执其实只是节目设计的综艺效果，实际录制氛围相当轻松。",
      "节目组在官方账号发布说明，表示网传视频为多段素材拼接而成，已联系平台处理不实内容，并呼吁观众以正片为准。",
      "值得注意的是，这已经不是该节目第一次遭遇未剪辑素材外流。有从业者在评论区指出，综艺现场素材外泄属于行业常见风险，往往在播出前被放大解读。",
    ],
    timeline: [
      { date: "09-04", text: "短视频在娱乐讨论群中流传" },
      { date: "09-05", text: "录制翻车话题扩散，登上热搜榜" },
      { date: "09-06", text: "节目组发声明，称视频为拼接内容" },
      { date: "09-08", text: "正片播出，争议逐渐平息" },
    ],
    related: ["variety-editing-dispute", "idol-debut-controversy"],
  },
  {
    id: "screen-casting-swap",
    title: "古装大剧临阵换角事件完整时间线",
    category: "screen",
    categoryName: "影视争议",
    year: "2024",
    date: "2024-06-22",
    heat: 878,
    badge: "议",
    featured: true,
    views: "176.9万",
    readTime: "8 分钟",
    status: "已官宣",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20film%20clapperboard%20and%20stacked%20script%20pages%20on%20a%20dark%20wooden%20table%20under%20warm%20spotlight%2C%20empty%20director%20chair%20in%20background%2C%20moody%20cinematic%20still%20life%2C%20deep%20red%20and%20amber%20accents%2C%20no%20text%2C%20no%20faces&width=800&height=450&seq=baoliao-ev-03&orientation=landscape",
    summary:
      "一部备受期待的古装剧在开机前一个月突然调整主演阵容，原定男主被替换。从路透曝光到官方官宣，事件经历了近两周的反复。",
    tags: ["换角", "开机延期", "官宣阵容"],
    content: [
      "该剧早在半年前就公布了概念海报与主创阵容，原定男主角的定妆照也曾在小范围流传。开机前一个月，有媒体拍到剧组重新搭建场景，原定主演未出现在片场。",
      "最初的说法是档期冲突，随后又有消息称是角色形象与演员气质不符。由于官方迟迟未回应，各种版本的传闻在社交平台并行传播。",
      "两周后，片方发布正式海报，新阵容亮相，并配文感谢等待，一切就绪。原定主演方面也发布动态，称双方友好协商，期待下次合作。",
      "业内普遍认为，开机前换角在影视行业并不罕见，但像这样受关注的项目在临近开机时调整，确实会带来成本与舆论的双重压力。",
    ],
    timeline: [
      { date: "06-05", text: "媒体拍到剧组重新搭景，原定主演缺席" },
      { date: "06-11", text: "档期冲突说法率先出现" },
      { date: "06-17", text: "角色适配度传闻扩散，官方保持沉默" },
      { date: "06-22", text: "片方发布新阵容海报，事件官宣落定" },
    ],
    related: ["screen-box-office-rumor", "brand-endorsement-pull"],
  },
  {
    id: "music-album-delay",
    title: "年度专辑反复延期：一场沉默的拉锯",
    category: "music",
    categoryName: "乐坛动态",
    year: "2024",
    date: "2024-04-30",
    heat: 803,
    badge: "热",
    featured: false,
    views: "143.2万",
    readTime: "6 分钟",
    status: "进行中",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20recording%20studio%20with%20mixing%20console%20lights%20and%20a%20lone%20microphone%20under%20warm%20amber%20glow%2C%20deep%20shadows%2C%20cinematic%20atmosphere%2C%20analog%20equipment%20details%2C%20no%20people%2C%20editorial%20mood%20photography&width=800&height=450&seq=baoliao-ev-04&orientation=landscape",
    summary:
      "一张从年初预告到年末仍未上线的专辑，让延期本身成了话题。制作方、平台与听众之间，展开了一场没有硝烟的拉锯。",
    tags: ["专辑延期", "制作周期", "听众耐心"],
    content: [
      "专辑的最初预告出现在年初，官方账号发布了一段十几秒的音频片段，配文很快就见面。按照当时的说法，完整专辑会在上半年与听众见面。",
      "进入下半年，专辑仍未上线。官方先后三次更新进度，理由分别是精益求精、版权流程与配合巡演节奏，每次都配上一张工作室照片。",
      "听众的情绪逐渐从期待转向疲惫。有人整理出完整的时间线发在超话，也有人表示理解创作需要时间，但希望给出明确的节点。",
      "截至本文整理时，专辑依旧处于即将上线的状态。有音乐制作人在访谈中提到，当下数字专辑的制作与宣发链条更长，延期并不一定意味着项目出了问题。",
    ],
    timeline: [
      { date: "01-12", text: "官方发布音频片段，预告上半年上线" },
      { date: "05-20", text: "首次更新进度，称精益求精" },
      { date: "08-09", text: "第二次更新，提及版权流程" },
      { date: "11-02", text: "第三次更新，称配合巡演节奏" },
    ],
    related: ["music-festival-cancel", "idol-debut-controversy"],
  },
  {
    id: "brand-endorsement-pull",
    title: "代言海报连夜下架：连锁反应如何发生",
    category: "brand",
    categoryName: "商业代言",
    year: "2024",
    date: "2024-03-12",
    heat: 869,
    badge: "爆",
    featured: true,
    views: "198.4万",
    readTime: "7 分钟",
    status: "已换人",
    cover:
      "https://readdy.ai/api/search-image?query=Blank%20glowing%20advertising%20lightbox%20on%20a%20city%20wall%20at%20dusk%20with%20warm%20amber%20reflections%2C%20abstract%20blurred%20passersby%2C%20cinematic%20urban%20editorial%20photography%2C%20deep%20red%20highlights%2C%20no%20text%2C%20no%20readable%20logos&width=800&height=450&seq=baoliao-ev-05&orientation=landscape",
    summary:
      "某品牌在深夜撤下了线下门店与线上商城的全部代言物料，第二天官宣新的合作对象。整个过程没有铺垫，也没有解释。",
    tags: ["代言更替", "物料调整", "品牌策略"],
    content: [
      "最早发现异常的是线下门店的员工。他们在工作群里提到，前一天还挂在门口的巨幅海报被要求连夜撤下，替换物料的到货时间未定。",
      "几乎同一时间，品牌线上商城的首页视觉也完成了更新，原代言人的相关页面显示为空。动作之快，让不少网友猜测双方合作出现了变故。",
      "次日上午，品牌发布新的合作官宣，用词是全新篇章。原代言人工作室未作回应，相关话题下聚集了大量讨论。",
      "有营销从业者分析，品牌更换代言通常与合约周期、舆情评估或业务重心调整有关，物料下架的速度取决于内部审批效率，并不必然对应负面事件。",
    ],
    timeline: [
      { date: "03-10", text: "线下门店连夜撤下代言海报" },
      { date: "03-11", text: "线上商城视觉同步更新，相关页面清空" },
      { date: "03-12", text: "品牌官宣新的合作对象" },
      { date: "03-15", text: "营销从业者就代言更替机制展开讨论" },
    ],
    related: ["screen-casting-swap", "idol-debut-controversy"],
  },
  {
    id: "idol-debut-controversy",
    title: "新人男团出道曲争议始末",
    category: "idol",
    categoryName: "偶像生态",
    year: "2024",
    date: "2024-01-25",
    heat: 791,
    badge: "议",
    featured: false,
    views: "121.7万",
    readTime: "5 分钟",
    status: "已回应",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20concert%20stage%20with%20silhouetted%20microphone%20stand%2C%20falling%20confetti%20in%20warm%20gold%20light%20and%20deep%20shadows%2C%20cinematic%20atmosphere%2C%20no%20faces%2C%20no%20text%2C%20high%20contrast%20editorial%20photography&width=800&height=450&seq=baoliao-ev-06&orientation=landscape",
    summary:
      "一支新人男团的出道曲上线当天，就因旋律相似度问题被推上风口浪尖。公司与创作者先后发声，事件在四十八小时内快速走完流程。",
    tags: ["出道曲", "旋律争议", "官方说明"],
    content: [
      "出道曲上线数小时后，有音乐区博主发布对比视频，指出副歌部分与一首数年前的作品存在听感相似。视频播放量迅速突破百万。",
      "随后，更多听众加入比对，讨论从是否相似延伸到编曲套路是否普遍。也有专业音乐人提醒，相似与否需要专业鉴定，不能仅凭听感下结论。",
      "上线第二天，公司发布声明，表示已注意到相关讨论，正在与制作方核实，并感谢大家的监督。次日补充说明称，已决定对编曲部分进行修改后重新上线。",
      "事件最终以作品修改告一段落。对一支刚出道的新人团体来说，这次风波既是压力，也是一次被更多人认识的机会。",
    ],
    timeline: [
      { date: "01-23", text: "出道曲上线，对比视频出现" },
      { date: "01-24", text: "讨论扩展到编曲套路层面" },
      { date: "01-25", text: "公司发布声明称正在核实" },
      { date: "01-27", text: "宣布修改编曲后重新上线" },
    ],
    related: ["music-album-delay", "variety-backstage-clash"],
  },
  {
    id: "love-split-statement",
    title: "和平分手声明背后：完整时间线还原",
    category: "love",
    categoryName: "情感八卦",
    year: "2023",
    date: "2023-10-09",
    heat: 845,
    badge: "热",
    featured: true,
    views: "263.1万",
    readTime: "7 分钟",
    status: "已结束",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20empty%20cafe%20chairs%20facing%20a%20rainy%20window%20with%20soft%20warm%20reflections%2C%20muted%20amber%20and%20deep%20brown%20tones%2C%20quiet%20melancholic%20cinematic%20mood%2C%20no%20people%2C%20editorial%20still%20life%20photography&width=800&height=450&seq=baoliao-ev-07&orientation=landscape",
    summary:
      "一份措辞克制的分手声明，让持续两年的感情传闻画上句号。回头看，其实早在数月前就有迹可循。",
    tags: ["分手声明", "时间线", "和平协商"],
    content: [
      "两位艺人的感情话题始于两年多前的一次合作。此后每逢重要节点，都会被网友发现同款与同城的蛛丝马迹，但双方始终未正面回应。",
      "当年夏天，有人注意到两人社交账号的互动明显减少，共同出席的场合也不再同框。相关猜测开始出现，但都停留在讨论层面。",
      "十月初，双方通过工作室联合发布声明，用和平协商、回归朋友作为定性，并感谢外界的关心，同时请求尊重个人选择。",
      "声明发布后，话题很快从是否分手转向如何体面告别。不少网友认为，这份克制的声明在当下快节奏的舆论环境里显得难得。",
    ],
    timeline: [
      { date: "07-18", text: "社交账号互动减少，被网友留意" },
      { date: "09-02", text: "共同出席活动不再同框" },
      { date: "10-09", text: "双方联合发布分手声明" },
      { date: "10-12", text: "话题转向对体面告别的讨论" },
    ],
    related: ["love-night-photo", "variety-editing-dispute"],
  },
  {
    id: "variety-editing-dispute",
    title: "综艺剪辑争议与当事人回应全记录",
    category: "variety",
    categoryName: "综艺风波",
    year: "2023",
    date: "2023-08-14",
    heat: 762,
    badge: "议",
    featured: false,
    views: "154.8万",
    readTime: "6 分钟",
    status: "已回应",
    cover:
      "https://readdy.ai/api/search-image?query=Video%20editing%20suite%20with%20multiple%20glowing%20monitors%20and%20timeline%20software%20glow%20in%20a%20dark%20room%2C%20warm%20amber%20screen%20light%2C%20cinematic%20atmosphere%2C%20no%20people%2C%20no%20readable%20text%2C%20editorial%20photography&width=800&height=450&seq=baoliao-ev-08&orientation=landscape",
    summary:
      "一期综艺播出后，某嘉宾的言行被指前后矛盾，引发对其个人形象的讨论。三天后，当事人发布长文回应。",
    tags: ["剪辑争议", "人设讨论", "回应长文"],
    content: [
      "争议起源于节目中一段对话的呈现方式：同一嘉宾在不同环节的说法被剪在一起，给观众造成了前后不一的观感。",
      "节目播出当晚，相关片段被大量二次剪辑传播。支持者认为这是综艺效果，反对者则将其上升到对嘉宾本人的评价。",
      "三天后，嘉宾发布长文，逐条说明了录制时的实际情境，并表示理解剪辑节奏，但希望大家能看到完整的表达。节目组随后转发回应，称尊重每位嘉宾的表达。",
      "事件让综艺剪辑这一老话题再次被讨论。有从业者指出，时长限制下剪辑必然带有取舍，观众观看时不妨多留一分余地。",
    ],
    timeline: [
      { date: "08-11", text: "节目播出，相关片段被二次传播" },
      { date: "08-12", text: "前后矛盾的说法登上话题榜" },
      { date: "08-14", text: "嘉宾发布回应长文，节目组转发" },
      { date: "08-20", text: "讨论转向综艺剪辑的行业惯例" },
    ],
    related: ["variety-backstage-clash", "screen-box-office-rumor"],
  },
  {
    id: "screen-box-office-rumor",
    title: "票房数据风波与行业的一次公开讨论",
    category: "screen",
    categoryName: "影视争议",
    year: "2023",
    date: "2023-05-21",
    heat: 718,
    badge: "议",
    featured: false,
    views: "96.5万",
    readTime: "6 分钟",
    status: "已说明",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20cinema%20hall%20with%20rows%20of%20empty%20red%20velvet%20seats%20and%20a%20glowing%20blank%20screen%2C%20warm%20amber%20light%20beams%2C%20cinematic%20nostalgic%20atmosphere%2C%20no%20people%2C%20editorial%20film%20photography&width=800&height=450&seq=baoliao-ev-09&orientation=landscape",
    summary:
      "一部电影的票房数据在两天内出现异常波动，引发关于统计口径的讨论。发行方与数据平台先后给出说明。",
    tags: ["票房数据", "行业讨论", "公开说明"],
    content: [
      "异常最早由影迷发现：某工作日的午夜场数据显示出与往常不符的增长曲线，相关截图在影迷社群中快速传播。",
      "随后，数据平台发布技术说明，解释为系统合并统计导致的短暂显示误差，并称已修正。发行方也补充说明，实际排片与售票情况正常。",
      "尽管官方给出了解释，讨论并未立刻停止。有从业者借此呼吁行业公开更细致的统计口径，让数据更透明。",
      "事件最终没有影响到影片的整体成绩，但关于数据可信度的讨论，成为当年电影行业的一个小注脚。",
    ],
    timeline: [
      { date: "05-19", text: "影迷发现午夜场数据异常" },
      { date: "05-20", text: "相关截图在社群扩散" },
      { date: "05-21", text: "平台发布技术说明并修正数据" },
      { date: "05-25", text: "行业呼吁公开统计口径" },
    ],
    related: ["screen-casting-swap", "music-festival-cancel"],
  },
  {
    id: "music-festival-cancel",
    title: "音乐节临时取消的善后处理复盘",
    category: "music",
    categoryName: "乐坛动态",
    year: "2023",
    date: "2023-07-02",
    heat: 689,
    badge: "热",
    featured: false,
    views: "88.2万",
    readTime: "5 分钟",
    status: "已善后",
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20open-air%20festival%20field%20with%20empty%20stage%20scaffolding%20and%20warm%20stage%20lights%20cutting%20through%20mist%20at%20night%2C%20cinematic%20moody%20atmosphere%2C%20deep%20red%20and%20amber%20tones%2C%20no%20people%2C%20editorial%20photography&width=800&height=450&seq=baoliao-ev-10&orientation=landscape",
    summary:
      "因连续强降雨，一场筹备半年的户外音乐节在开幕前一天宣布取消。主办方随后公布的退票与补偿方案，成为讨论焦点。",
    tags: ["音乐节取消", "退票方案", "天气原因"],
    content: [
      "取消通知发布于开幕前一天的深夜。主办方称，受连续强降雨影响，场地存在安全隐患，经多方评估后决定取消全部场次。",
      "消息传出后，社交平台上聚集了大量已预订机票酒店的观众。最初的焦虑集中在票款怎么办，随后转为对补偿范围的讨论。",
      "三天后，主办方公布方案：全额退票，并为持票观众提供周边与下届优先购票权益。对于交通住宿损失，则表示将与平台协商提供部分优惠。",
      "方案公布后，舆论逐渐转向理解。有演出行业人士表示，户外活动的天气风险难以完全规避，关键在于善后是否及时、透明。",
    ],
    timeline: [
      { date: "06-30", text: "发布取消通知，称受强降雨影响" },
      { date: "07-01", text: "观众关注票款与交通住宿损失" },
      { date: "07-02", text: "主办方公布退票与补偿方案" },
      { date: "07-06", text: "舆论转向对善后机制的讨论" },
    ],
    related: ["music-album-delay", "screen-box-office-rumor"],
  },
];

export type EventItem = (typeof events)[number];